<template>
  <div>
    <base-header type class="rsgradient pb-3 pb-1 pt-3 pt-md-5"></base-header>
    <b-card style="margin: 20px">
      <b-card-header header-tag="header" class="p-1" role="tab">Cobrar con QR</b-card-header>
      <b-card-body v-if="model.ShowCreateChargeWithQRSection">
        <div class="row form-group">
          <div class="col-md-12 text-center">
            <img src="@/assets/cobrar_qr.png" />
          </div>
          <div class="col-md-12 text-center">
            <label>Pedile a tu cliente que escanee el código QR con la App de su billetera o banco.</label>
          </div>
        </div>
        <div class="row form-group">
          <div class="col-md-12">
            <label>Importe</label>
            <vue-numeric
              currency="$"
              v-bind:precision="2"
              decimal-separator="."
              thousand-separator=" "
              v-model="model.Request.Amount"
              class="form-control"
            ></vue-numeric>
          </div>
        </div>
        <div class="row form-group">
          <div class="col-md-12">
            <label>Motivo</label>
            <base-input v-model="model.Request.Reference"></base-input>
          </div>
        </div>
        <div class="row form-group">
          <div class="col-md-12">
            <save-button text="Cobrar" @click="ChargeWithQR"></save-button>
          </div>
        </div>
      </b-card-body>
      <b-card-body v-if="!model.ShowCreateChargeWithQRSection">
        <div class="row">
          <div class="col-md-12 text-center">
            <label>Total a Cobrar:</label>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 text-center">
            <label>
              <b>$ {{model.Request.Amount}}</b>
            </label>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 text-center">
            <label>Pedile a tu cliente que escanee el código con su app.</label>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 text-center">
            <img
              v-bind:src="'data:'+model.Response.ImageType+';base64,' + model.Response.QRBase64"
              class="responsiveImage"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <base-button type="primary" size="sm" @click="Cancel">
              <i class="fa fa-arrow-left fa-fw"></i>Volver
            </base-button>
          </div>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import axiosHelpers from "@/helpers/axiosHelpers";
import notificationHelpers from "@/helpers/notificationHelpers";

export default {
  components: {},
  data() {
    return {
      model: {
        Request: {
          Amount: 0,
          Reference: ""
        },
        Response: {
          ImageType: "",
          QRBase64: "",
          ChargeID: 0
        },
        ShowCreateChargeWithQRSection: true
      }
    };
  },
  methods: {
    ChargeWithQR() {
      let context = this;

      if (context.model.Request.Amount <= 0) {
        notificationHelpers.showWarning(
          "Advertencia!",
          "El importe debe ser mayor a 0",
          context
        );
        return;
      }

      axiosHelpers.axiosPost(
        "Commerce/ChargeWithQRCreate",
        context.model.Request,
        this,
        function(data) {
          if (data.Alerts.length == 0) {
            context.model.Response = data.ResponseVM;
            context.model.ShowCreateChargeWithQRSection = false;   
          } else {
             context.$router.push("dashboard");
          }
        }
      );
    },
    Cancel() {
      let context = this;

      var req = { ChargeID: context.model.Response.ChargeID };

      axiosHelpers.axiosPost("Commerce/ChargeWithQRCancel", req, this, function(
        data
      ) {
        context.model.Request.Amount = 0;
        context.model.Request.Reference = "";

        context.model.ShowCreateChargeWithQRSection = true;
      });
    }
  }
};
</script>
<style scoped>
.responsiveImage {
  max-width: 40%;
  width: auto;
  height: auto;
}
</style>